module.exports = __webpack_public_path__ + "static/media/bkg_1.6eefe215.jpg";